import * as axios from 'axios'
import qs from 'qs'
import { getCurrentUser } from '../services/userProfile'
import { getUser } from './user'
// import { app as firebase, config } from './firebase';

export const getAuthHeaders = function () {
  let userObj = null

  try {
    userObj = getUser()

    const userToken = userObj.tokens.identity.value
    return { Authorization: `Bearer ${userToken}` }
  } catch (err) {
    console.error('LOCAL USER FAILURE', err)
    getCurrentUser()
      .then(user => {
        const userToken = user.data.tokens.identity.value
        return { Authorization: `Bearer ${userToken}` }
      })
      .catch(err => {
        console.error('USER ACCESS FAILURE', err)
      })
  }
}

export const request = async (method, path, params) => {
  let headers = getAuthHeaders()
  if (params.headers != null) {
    headers = {
      ...headers,
      ...params.headers
    }
  }

  return axios({
    headers,
    method,
    url: path,
    params: params.queryParams,
    data: params.body,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
  })
    .then(response => {
      /*
      #TODO: Why isn't the API returning a non-200 when it's failing...
      -- TJC - April 05, 2021
    */
      if (response.data.success != null && response.data.success == false) {
        return { success: false, data: { ...response.data } }
      }
      return { success: true, data: response.data }
    })
    .catch(error => {
      return { success: false, data: error }
    })
}

export const stateInfoRequest = async (method, path, params) => {
  let result = null

  const config = {
    method,
    params,
    url: path
  }
  try {
    const request = await axios(config)
    result = { success: true, data: request }
  } catch (error) {
    result = { success: false, data: error }
  }

  return result
}
